// extracted by mini-css-extract-plugin
var _1 = "TagActions-moduleactions__c8j9x";
export { _1 as "actions" }
